import { render, staticRenderFns } from "./BusesCreate.vue?vue&type=template&id=077db998"
import script from "./buses_create.js?vue&type=script&lang=js&external"
export * from "./buses_create.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports